// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var MomentRe$ReactHooksTemplate = require("../MomentRe.res.js");

function empty(param) {
  return {
          id: undefined,
          value: undefined,
          startDate: undefined,
          endDate: undefined
        };
}

function convertDateToMoment(date) {
  if (date !== undefined) {
    return Caml_option.some(MomentRe$ReactHooksTemplate.moment(undefined, date));
  }
  
}

function id(t) {
  return t.id;
}

function value(t) {
  return t.value;
}

function startDate(t) {
  return t.startDate;
}

function endDate(t) {
  return t.endDate;
}

function setStartDate(t, startDate) {
  return {
          id: t.id,
          value: t.value,
          startDate: startDate,
          endDate: t.endDate
        };
}

function setEndDate(t, endDate) {
  return {
          id: t.id,
          value: t.value,
          startDate: t.startDate,
          endDate: endDate
        };
}

function setDateRange(t, startDate, endDate) {
  return {
          id: t.id,
          value: t.value,
          startDate: startDate,
          endDate: endDate
        };
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          value: convertDateToMoment(Json_decode.withDefault(undefined, (function (param) {
                      return Json_decode.field("value", (function (param) {
                                    return Json_decode.optional(Json_decode.string, param);
                                  }), param);
                    }), json)),
          startDate: convertDateToMoment(Json_decode.withDefault(undefined, (function (param) {
                      return Json_decode.field("start_date", (function (param) {
                                    return Json_decode.optional(Json_decode.string, param);
                                  }), param);
                    }), json)),
          endDate: convertDateToMoment(Json_decode.withDefault(undefined, (function (param) {
                      return Json_decode.field("end_date", (function (param) {
                                    return Json_decode.optional(Json_decode.string, param);
                                  }), param);
                    }), json))
        };
}

function getMomentString(date) {
  if (date !== undefined) {
    return Caml_option.valFromOption(date).format("YYYY-MM-DD HH:mm:SS");
  } else {
    return "";
  }
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "start_date",
                  getMomentString(t.startDate)
                ],
                tl: {
                  hd: [
                    "end_date",
                    getMomentString(t.endDate)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

var dataTypeName = "DateType";

exports.empty = empty;
exports.dataTypeName = dataTypeName;
exports.id = id;
exports.value = value;
exports.startDate = startDate;
exports.endDate = endDate;
exports.setStartDate = setStartDate;
exports.setEndDate = setEndDate;
exports.setDateRange = setDateRange;
exports.decode = decode;
exports.encode = encode;
/* MomentRe-ReactHooksTemplate Not a pure module */
